import React from "react";
import { FOOTER } from "../../../layout/kor/footer";
import { SUBHEADER } from "../../../layout/kor/subheader";
import { Management } from "../../../parts/kor/business/management";
export const MANAGEMENT = () => {
  return (
    <main id="content">
      <SUBHEADER />
      <div id="business">
        <Management />
      </div>
      <FOOTER />
    </main>
  );
};
